import React, { Component } from 'react';

/**
 * note- the contextType is cleaner but it doesnt' test well.
 * @param bottle
 */
export default (bottle) => {
  bottle.factory('CallbackContainer', ({ CallbackView }) => class CallbackContainer extends Component {
    componentDidMount() {
      const { profile, history } = this.props;

      if (profile && history) {
        history.push('/');
      } else { this.props.startFromCallback(); }
    }

    componentDidUpdate() {
      const { profile, history } = this.props;

      if (profile && history) {
        history.push('/');
      }
    }

    render() {
      const props = { ...this.props };
      delete props.children;
      return <CallbackView {...props} />;
    }
  });
};
